import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";

import {
  drawerWidth,
  GeneralAdminRoutes,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../../constants";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";

import { AlbumDetailsDataFieldsSection } from "../../components/components";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import { useAlbumsContext } from "../../../../../providers/OrganizationAdmin/AlbumProvider";
import { Toast } from "../../../../../common/alert";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import CommonTable from "../../../../../common/CommonTable";
import TableSearchBar from "../../../../../common/TableSearchBar";
import CommonHeader from "../../../../../common/CommonHeader";
import QuickTalesTableRow from "../../../../../common/QuickTalesTableRow";
import {
  updateAlbum,
  quickTalesSearch,
  uploadQuickTaleAudioToStorage,
  getAlbumbyId,
  uploadAlbumImageToStorage,
} from "../../../../../modules/OrganizationAlbums/hooks/AlbumsHooks";
import { getSingleUser } from "../../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { useAuth } from "../../../../../hooks";

const GAAlbumDetailsContainer = () => {
  const { currentUser } = useAuth();

  const { handleGetAllGAAlbums, loading, setLoading, handleQuicktalesData } =
    useAlbumsContext();
  const location = useLocation();
  const navigate = useNavigate();

  const [albumDetails, setAlbumDetails] = useState(location?.state?.albumDetails || {});
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedQuickTales, setSelectedQuickTales] = useState([]);
  const [quickDetail, setQuickDetail] = useState([]);
  const [uploadAudioFile, setUploadAudioFile] = useState(null);

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    // Check if we have no data - redirect to parent page
    if (!location?.state?.albumDetails?.id) {
      navigate('/albums', { replace: true });
      return;
    }

    fetchAlbumDetails();
  }, [location.state, navigate]);

  // Don't render anything if we don't have valid album data
  if (!albumDetails?.id) {
    return null;
  }

  const fetchAlbumDetails = async () => {
    try {
      const albumId = location.state.albumDetails.id;
      const albumData = await getAlbumbyId(albumId);

      const quicktale = albumData.data().quicktales;
      const quicktalesInfo = await handleQuicktalesData(quicktale);

      let userTemp = await getSingleUser(albumData?.data()?.user);
      let data = {
        ...albumData?.data(),
        id: albumData?.id,
        userData: userTemp?.data() ? userTemp?.data() : null,
        quicktaleData: quicktalesInfo?.quicktaleData,
      };
      setAlbumDetails(data);
      setQuickDetail(data?.quicktaleData);
      console.log("album details", data);
    } catch (error) {
      console.error("Error fetching area details:", error);
    }
  };

  const handleUpdateAlbum = async () => {
    try {
      setLoading(true);

      let dataTemp = {
        title: albumDetails?.title ?? "",
        description: albumDetails?.description ?? "",
        privacy: albumDetails?.privacy ?? "",
        // createdBy: albumDetails.createdBy,
        // user: albumDetails?.user,
        // createdBy: albumDetails.createdBy,
      };

      if (albumDetails?.createdBy) {
        dataTemp.createdBy = albumDetails.createdBy;
      }
      if (albumDetails?.user) {
        dataTemp.user = albumDetails.user;
      }

      if (uploadImage != null) {
        // let photoUrl = await uploadQuickTaleImageToStorage(uploadImage?.raw);
        let photoUrl = await uploadAlbumImageToStorage(uploadImage?.raw);
        dataTemp.photoUrl = photoUrl;
        dataTemp.originalPhotoName = uploadImage?.raw?.name;
      }
      if (uploadAudioFile != null) {
        let audioUrl = await uploadQuickTaleAudioToStorage(
          uploadAudioFile?.raw
        );
        dataTemp.audioUrl = audioUrl;
        dataTemp.originalAudioName = uploadAudioFile?.raw?.name;
      }

      // console.log("dataTempDetail", dataTemp);
      // console.log("albumTitle", albumDetails.albumTitle);
      let responseTemp = await updateAlbum(albumDetails.id, dataTemp);
      // console.log("responseTemp", responseTemp);
      await handleGetAllGAAlbums();
      console.log("update Album response:", responseTemp);
      showNotification("Album updated successfully.");
      // Toast("success", "Album updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating Album", error.message);
    } finally {
      setLoading(false);
      setEditEnabled(false);
    }
  };

  const handleSearchAlbumsQuickTales = async (e) => {
    try {
      let value = e.target.value;

      if (value.length >= 1) {
        // setSearchValue(quickDetail);
        // console.log("searching", quickDetail);
        let quicktaleSearchTemp = await quickTalesSearch(quickDetail, value);
        setQuickDetail(quicktaleSearchTemp);
      } else {
        setQuickDetail(albumDetails.quicktaleData);
      }
    } catch (error) {
      console.log("error searching album:", error.message);
    }
  };

  const handleRemoveQuickTale = async (selectedQuicktales) => {
    try {
      let quicktales = albumDetails.quicktales;
      // Filter out the selectedQuicktales from the current quicktales
      const updatedQuicktales = quicktales.filter(
        (qt) => !selectedQuicktales.includes(qt)
      );
      let dataTemp = {
        quicktales: updatedQuicktales,
      };

      let responseTemp = await updateAlbum(albumDetails.id, dataTemp);
      setAlbumDetails((prevDetails) => ({
        ...prevDetails,
        quicktales: updatedQuicktales,
      }));
      setQuickDetail((prevList) =>
        prevList.filter((item) => !selectedQuicktales.includes(item.id))
      );
      showNotification("Album quicktales removed successfully.");
      // Toast("success", "Album quicktales removed successfully.");
      await handleGetAllGAAlbums();
      setSelectedQuickTales([]);
    } catch (error) {
      console.log("error updating album quicktales:", error.message);
    }

    // setQuickDetail(selected);
  };

  return (
    <Box sx={{ display: "flex", width: `calc(100% - ${drawerWidth}px)` }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={albumDetails && albumDetails.title && albumDetails.title}
        bgColor="#fff"
        buttonText={currentUser?.role === "moderator" ? undefined : "Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        // handleSave={() => setEditEnabled(false)}
        handleSave={() => handleUpdateAlbum()}
        loading={loading}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <AlbumDetailsDataFieldsSection
            albumDetails={albumDetails}
            setAlbumDetails={setAlbumDetails}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            setEditEnabled={setEditEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
          />

          <CommonHeader
            mainTitle={"QuickTales"}
            bgColor="#fff"
            buttonText={"Add QuickTales"}
            handleSubmit={() => {
              navigate(GeneralAdminRoutes.addQTsToGAAlbum, {
                state: { albumDetails },
              });
            }}
          />
          <TableSearchBar
            selected={selectedQuickTales}
            setSelected={setSelectedQuickTales}
            placeholder={"Search"}
            handleSearch={handleSearchAlbumsQuickTales}
            handleUpdateAlbum={handleUpdateAlbum}
            handleRemove={handleRemoveQuickTale}
          />

          <CommonTable
            moduleDetails={albumDetails}
            module="album"
            tableData={quickDetail}
            setTableData={setQuickDetail}
            handleSavePosition={async (quicktalesData) => {
              try {
                let temp = {
                  quicktales: quicktalesData,
                };
                // console.log("temp data:::", temp)
                // console.log("id data:::", albumDetails.id)
                await updateAlbum(albumDetails.id, temp);
              } catch (error) {
                console.log("error re-ordering qts:", error.message);
              }
            }}
            selected={selectedQuickTales}
            setSelected={setSelectedQuickTales}
            CommonTableRow={QuickTalesTableRow}
            removeRow={handleRemoveQuickTale}
            showPosition={true}
          />
        </Grid>
      </Grid>
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          uploadImage != null && uploadImage.preview
            ? uploadImage.preview
            : // : images.tableDummyImage
              albumDetails?.photoUrl
        }
      />
    </Box>
  );
};

export default GAAlbumDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
